import { useSelector } from "react-redux";

export default function NtwContentHeader() {
  const newTemplate = useSelector((state) => state.newTemplate);

  return (
    <div className="ntw-content-header">
      <span className="RECORD padding-right-8"></span>
      <span>{newTemplate.newTemplateOptionTitle || ""}</span>
    </div>
  )
}